export const STATE_NAME = 'modalsLogic';
